import React, { useEffect } from "react";

function TranslateComponent() {
  useEffect(() => {
    const scriptId = "google-translate-script";

    // Prevent duplicate script loading
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src =
        "//translate.google.com/translate_a/element.js?cb=initGoogleTranslate";
      script.async = true;
      document.body.appendChild(script);
    }

    // Initialize Google Translate
    window.initGoogleTranslate = () => {
      new window.google.translate.TranslateElement(
        { pageLanguage: "en", autoDisplay: false },
        "google_translate_element"
      );
    };

    // Function to remove unwanted Google Translate UI elements
    const removeGoogleUI = () => {
      document
        .querySelectorAll(
          ".goog-tooltip, .VIpgJd-ZVi9od-l4eHX-hSRGPd, .goog-te-balloon-frame, .goog-te-banner-frame, #goog-gt-tt"
        )
        .forEach((el) => el.remove());

      // Hide unwanted iframes and "skiptranslate" div
      document
        .querySelectorAll("iframe, .skiptranslate")
        .forEach((el) => (el.style.display = "none"));

      // Ensure body margin isn't affected
      document.body.style.top = "0px";
    };

    // Run UI cleanup every 500ms
    const intervalId = setInterval(removeGoogleUI, 500);

    return () => {
      clearInterval(intervalId); // Cleanup interval on unmount
    };
  }, []);

  return (
    <>
      {/* Hide unwanted elements using CSS */}
      <style>
        {`
          .skiptranslate, iframe[style*="visibility: visible"] {
            display: none !important;
          }
          body { top: 0px !important; }
        `}
      </style>
      <div id="google_translate_element" style={{ display: "none" }}></div>
    </>
  );
}

export default TranslateComponent;